import React, { useState } from "react";
import { Alert, Typography, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { CsvParseResult, parseCsvFile } from "../parseCsv";

const { Dragger } = Upload;
const { Text } = Typography;

interface Props {
  onParsed: (result: CsvParseResult, file: File) => void;
}

const UploadStep = ({ onParsed }: Props) => {
  const { t } = useTranslation("CsvImport");
  const [error, setError] = useState<string | null>(null);
  const [parsing, setParsing] = useState(false);

  const handleFile = async (file: File) => {
    setError(null);
    setParsing(true);
    try {
      const result = await parseCsvFile(file);
      if (result.rows.length === 0) {
        setError(t("uploadErrorEmpty"));
        return;
      }
      onParsed(result, file);
    } catch {
      setError(t("uploadErrorParse"));
    } finally {
      setParsing(false);
    }
    // Prevent antd from uploading
    return false;
  };

  return (
    <div style={{ padding: "16px 0" }}>
      <Dragger
        accept=".csv,.CSV"
        multiple={false}
        showUploadList={false}
        disabled={parsing}
        beforeUpload={(file) => {
          handleFile(file);
          return false;
        }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          {parsing ? t("uploadParsing") : t("uploadDragText")}
        </p>
        <p className="ant-upload-hint">{t("uploadHint")}</p>
      </Dragger>

      {error && (
        <Alert
          type="error"
          message={error}
          style={{ marginTop: 16 }}
          showIcon
        />
      )}

      <Text type="secondary" style={{ display: "block", marginTop: 12 }}>
        {t("uploadPrivacyNote")}
      </Text>
    </div>
  );
};

export default UploadStep;
